<template>
  <div class="m-wrap m-wap">
    <Logo />
    <Banner />

    <!--提交成功-->
    <SuccessCon
      :platform="platform"
      v-if="!signSuccess && (isRefuse == '0' || isRefuse == null)"
    />

    <!--审核未通过-->
    <RefuseCon
      :platform="platform"
      v-if="!signSuccess && isRefuse != '0' && isRefuse != null"
    />

    <!--报名成功-->
    <SuccessPartCon
      :platform="platform"
      :posterInfo="posterInfo"
      v-if="signSuccess"
      @goInvite="goInvite"
    />

    <WapMeetEntry :seminarInfo="seminarInfo" v-if="!signSuccess" />
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import SuccessCon from "@/components/SuccessCon.vue";
import SuccessPartCon from "@/components/SuccessPartCon.vue";
import RefuseCon from "@/components/RefuseCon.vue";
import WapMeetEntry from "@/components/WapMeetEntry.vue";
import mixinMeeting from "../../mixin/meeting.js";
import mixinConfig from "../../mixin/config.js";
import mixinSuccess from "../../mixin/success.js";
import { SExtraFilter } from "../../../stempcore/src/core/sextra";

export default {
  name: "WapSuccess",
  mixins: [mixinMeeting, mixinConfig, mixinSuccess, SExtraFilter],
  components: {
    Logo,
    Banner,
    SuccessCon,
    SuccessPartCon,
    RefuseCon,
    WapMeetEntry,
  },
  data() {
    return {
      platform: "wap",
    };
  },
};
</script>
